// extracted by mini-css-extract-plugin
export default {"container":"VO-z","topReviewHeading":"WO-z","criticalReview":"XO-z","favorableReview":"YO-z","vsSeparator":"ZO-z"};